import React, { useState } from "react";
import Modal from "../../../components/general/Modal";
import {
  ChoiceText,
  CloseIcon,
  Container,
  Footer,
  Icon,
  InputContainer,
  Togle,
  SubTitle,
  Title,
  TogleGerente,
  TogleColaborador,
  StaticColab,
} from "./styles";
import NewUserIcon from "../../../assets/icons/NewUserIcon";
import Input from "../../../components/general/Input";
import Button from "../../../components/general/Button";
import Close from "../../../assets/icons/Close";
import { handleSendEmail } from "../../../state/users/actions";
import { useDispatch, useSelector } from "react-redux";
import { toastAlert } from "../../../components/Toastify/index";

const NewUserModal = ({ isOpen, onClose, onConfirm, filters }) => {
  const [newUserName, setNewUserName] = useState("");
  const [userNameError, setUserNameError] = useState(false);
  const [newUserEmail, setNewUserEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailInUse, setEmailInUse] = useState(false);
  const [newUserCargo, setNewUserCargo] = useState("colaborador");
  const user = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();

  const [typeFilter, updateFilters] = filters;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      selector="#root"
      className="nodrag"
    >
      <Container>
        <Icon>
          <NewUserIcon />
        </Icon>
        <Title>Novo Usuário</Title>
        <CloseIcon>
          <Close onClick={onClose} />
        </CloseIcon>
        <SubTitle>
          Convide colaboradores para seus times, monitore e gerencie as tarefas
          pelo Zaivu.
        </SubTitle>
        <InputContainer>
          <Input
            value={newUserName}
            setValue={(e) => {
              setNewUserName(e);
            }}
            label="Nome"
            placeholder={"Ex. Jorge Campos"}
            type="text"
            error={userNameError}
            errorMsg={"Pro favor preencha o Nome do novo usuário"}
          />
          <Input
            style={{ marginTop: "1.2rem" }}
            value={newUserEmail}
            setValue={(e) => {
              setNewUserEmail(e);
            }}
            label="Endereço de E-mail"
            placeholder={"Ex. usuario@empresa.com"}
            type="text"
            error={emailInUse || emailError}
            errorMsg={
              emailError
                ? "Pro favor preencha o email do novo usuário"
                : "Email já cadastrado"
            }
          />
        </InputContainer>
        <ChoiceText>Qual será o perfil de usuário do novo membro?</ChoiceText>
        {user?.rank === "admin" ? (
          <>
            <Togle>
              <TogleGerente
                newUserCargo={newUserCargo}
                onClick={() => setNewUserCargo("gerente")}
              >
                Gerente
              </TogleGerente>
              <TogleColaborador
                newUserCargo={newUserCargo}
                onClick={() => setNewUserCargo("colaborador")}
              >
                Colaborador
              </TogleColaborador>
            </Togle>
          </>
        ) : (
          <>
            <Togle>
              <StaticColab>Colaborador</StaticColab>
            </Togle>
          </>
        )}
        <Footer>
          <Button
            height={"2.75rem"}
            width={"7.95rem"}
            content={"Cancelar"}
            outline
            onClick={onClose}
          />
          <Button
            height={"2.75rem"}
            width={"7.95rem"}
            content={"Enviar"}
            style={{ marginLeft: "1rem", marginBottom: "2rem" }}
            onClick={() => {
              if (newUserName === "" || newUserEmail === "") {
                if (newUserName === "") setUserNameError(true);
                if (newUserEmail === "") setEmailError(true);
              } else {
                setUserNameError(false);
                setEmailError(false);
                dispatch(
                  handleSendEmail({
                    name: newUserName,
                    email: newUserEmail,
                    rank: newUserCargo,
                  })
                )
                  .then((res) => {
                    const newUser = res.payload.user;
                    toastAlert({
                      msg: `Conta do usuário ${newUser.username} criada com sucesso!`,
                    });
                    updateFilters({ ...typeFilter, page: 1 });
                    setEmailInUse(false);
                  })
                  .catch((err) => {
                    setEmailInUse(true);
                    toastAlert({
                      msg: `Houve um erro ao criar conta de usuário`,
                      isError: true,
                    });
                  });
                onClose();
              }
            }}
          />
        </Footer>
      </Container>
    </Modal>
  );
};

export default NewUserModal;
